$(document).ready(function() {
    searchBar.initiate();
});

var searchBar = {
    initiate: function() {
        $('#search_bar .button-do-search').on('click', this.doSearch);
    },
    doSearch: function() {
        var category = $('#search_category_slug').val();
        var occasion = $('.select-occasion').val();
        var region = $('.select-region').val();

        var url = "/categorie";

        if (category !== '-1') {
            url += '/' + category;
        } else {
            url = "/zoeken";
        }

        if (occasion !== "-1" || region !== "-1") {
            url += "?";
        }

        if (occasion !== "-1") {
            url += "occasion_id=" + occasion;
        }

        if (region !== "-1") {
            if (occasion !== "-1") {
                url += "&";
            }
            url += "region_id=" + region;
        }

        window.location = url;
    }
};
